import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
  addService,
  deleteService,
  getService,
  searchService,
  updateService,
} from '../../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
export default function CreateTable() {
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [serviceId, setServiceId] = useState();
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });
  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };

  const toggle = () => {
    setShow(!show);
  };
  const updateToggle = () => {
    setUpdateModal(!updateModal);
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const dispatch = useDispatch();
  const getProblems = useSelector((state) => state.master);

  const initialValues = {
    serviceName: '',
    serviceRate: '',
    seating: '',
    serviceGst: ''
  }

  const validationSchema = Yup.object().shape({
    serviceName: Yup.string().required('Service name is required'),
    serviceRate: Yup.string().required('Service Rate is required'),
    seating: Yup.string().required('Seating is required'),
    serviceGst: Yup.string().required('Seating is required'),
  })
  const [formData, setFormData] = useState({
    serviceName: '',
    serviceRate: '',
    seating: '',
  });

  const handleFile = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleServices = (values, { resetForm }) => {
    dispatch(addService(values, limits)).then(() => {
      toggle();
      resetForm();
    });
  };


  const handleUpadteProblam = (values) => {
    const payload = {
      serviceId: serviceId,
      serviceName: values.serviceName,
      serviceRate: values.serviceRate,
      seating: values.seating,
      serviceGst: values.serviceGst,
    };
    dispatch(updateService(payload, limits)).then(() => {
      setUpdateModal(false);
    });
  };

  const handleDeleteProblam = () => {
    dispatch(deleteService(serviceId, limits)).then(() => {
      deleteToggle();
      setMainPage(1);
    });
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchService(queryParams, newSearchParams.page));
  };

  // const ChangeMainPage = (selected) => {
  //   setMainPage(parseInt(selected.selected) + 1);
  // };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: parseInt(selected.selected) + 1,
    };
    setSearchDefault(updatedSearchParams);
    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchService(queryParams, updatedSearchParams.page));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    getProblems?.getService?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    if (searchQuery) {
      const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchService(queryParams, updatedSearchParams.page));
    } else {
      dispatch(getService(limits));
    }
  }, [mainPage, rowsPerPage, searchQuery]);

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-end">
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <Button
            onClick={toggle}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Service
          </Button>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className='mb-3 flex items-center justify-between mt-5'>
          <h3 className='fw-bold'>Service List</h3>
          <div className='ms-auto border-r pe-3 me-3'>Total Records: <span className='text-success border-b border-success'>{getProblems?.getService?.data?.totalCount || 0}</span></div>

          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Service Name</Th>
                <Th>Rate</Th>
                <Th>Seating</Th>
                <Th>GST</Th>
                <Th className="text-end">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getProblems?.getService?.data?.Services?.length > 0 ? (
                getProblems?.getService?.data?.Services?.map((res) => {
                  return (
                    <Tr key={res._id}>
                      <Td>{res.serviceName}</Td>
                      <Td>{res.serviceRate}</Td>
                      <Td>{res.seating}</Td>
                      <Td>{res.serviceGst}</Td>
                      <Td style={{ minWidth: '200px' }}>
                        <div className="d-flex gap-3 justify-end">
                          <FaEdit
                            onClick={() => {
                              updateToggle();
                              setFormData(res);
                              setServiceId(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-success"
                            title="update"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteToggle();
                              setServiceId(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-danger"
                            title="delete"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <>
                  <Tr>
                    <Td colSpan={5} textAlign="center">
                      Service Not Found
                    </Td>
                  </Tr>
                </>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      {/* add problem */}

      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Service</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleServices}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Service Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceName', e.target.value)}
                        value={values.serviceName}
                        placeholder="Enter Service Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Rate</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceRate"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceRate', e.target.value)}
                        value={values.serviceRate}
                        placeholder="Enter Rate"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceRate"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Seating</Form.Label>
                      <Form.Control
                        type="text"
                        name="seating"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('seating', e.target.value)}
                        value={values.seating}
                        placeholder="Enter Seating"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="seating"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>GST</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceGst"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceGst', e.target.value)}
                        value={values.serviceGst}
                        placeholder="Enter GST"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceGst"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                // onClick={handleCreateFile}
                >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* update problem */}

      <Modal show={updateModal} onHide={updateToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Update Service</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}  // This allows Formik to reset the initial values
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpadteProblam} // Formik will pass form values here
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Service Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceName', e.target.value)}
                        value={values.serviceName}
                        placeholder="Enter Service Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Rate</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceRate"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceRate', e.target.value)}
                        value={values.serviceRate}
                        placeholder="Enter Rate"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceRate"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Seating</Form.Label>
                      <Form.Control
                        type="text"
                        name="seating"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('seating', e.target.value)}
                        value={values.seating}
                        placeholder="Enter Seating"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="seating"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>GST</Form.Label>
                      <Form.Control
                        type="text"
                        name="serviceGst"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('serviceGst', e.target.value)}
                        value={values.serviceGst}
                        placeholder="Enter GST"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="serviceGst"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                // onClick={handleUpadteProblam}
                >
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete problem */}

      <Modal show={deleteModal} onHide={deleteToggle}>
        {/* <Modal.Header closeButton>
                    <Modal.Title>Delete Service</Modal.Title>
                </Modal.Header> */}

        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteProblam}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
